import React from "react";
import { Route, Switch } from "react-router-dom";
import TopoSomenteLogo from "../../components/TopoSomenteLogo";
import AtivarComCodigo from "./components/AtivarComCodigo";
import AtivarComQRCode from "./components/AtivarComQRCode";

export default class AtivarEquipamento extends React.Component {
  render() {
    return (
      <div>
        <TopoSomenteLogo />
        <Switch>
          <Route
            path="/ativar-equipamento/ativar-qr-code"
            component={AtivarComQRCode}
          />
          <Route
            path="/ativar-equipamento/ativar-codigo"
            component={AtivarComCodigo}
          />
        </Switch>
      </div>
    );
  }
}
